/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgClipboardUp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16 2v2h4v6h-2V6h-2v2H6V6H4v14h9v2H2V4l4-.001V2zm3 9.973 3.762 3.639L21.327 17 20 15.717V22h-2v-6.284L16.673 17l-1.435-1.388zM14 4H8.03l-.001 1.999H14z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgClipboardUp as ClipboardUp };
